function CloseCircleIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.4375 26.875C6.025 26.875 0 20.85 0 13.4375C0 6.025 6.025 0 13.4375 0C20.85 0 26.875 6.025 26.875 13.4375C26.875 20.85 20.85 26.875 13.4375 26.875ZM13.4375 1.875C7.0625 1.875 1.875 7.0625 1.875 13.4375C1.875 19.8125 7.0625 25 13.4375 25C19.8125 25 25 19.8125 25 13.4375C25 7.0625 19.8125 1.875 13.4375 1.875Z"
        fill="currentColor"
      />
      <path
        d="M9.89922 17.9127C9.66172 17.9127 9.42422 17.8252 9.23672 17.6377C8.87422 17.2752 8.87422 16.6752 9.23672 16.3127L16.3117 9.2377C16.6742 8.8752 17.2742 8.8752 17.6367 9.2377C17.9992 9.6002 17.9992 10.2002 17.6367 10.5627L10.5617 17.6377C10.3867 17.8252 10.1367 17.9127 9.89922 17.9127Z"
        fill="currentColor"
      />
      <path
        d="M16.9742 17.9127C16.7367 17.9127 16.4992 17.8252 16.3117 17.6377L9.23672 10.5627C8.87422 10.2002 8.87422 9.6002 9.23672 9.2377C9.59922 8.8752 10.1992 8.8752 10.5617 9.2377L17.6367 16.3127C17.9992 16.6752 17.9992 17.2752 17.6367 17.6377C17.4492 17.8252 17.2117 17.9127 16.9742 17.9127Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default CloseCircleIcon;
